function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#002060"
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  strokeMiterlimit: 9
}), React.createElement("g", null, React.createElement("path", {
  d: "m22.534 14.308c0-0.45844 0.37703-0.83005 0.84218-0.83005h4.248c0.46514 0 0.84218 0.3716 0.84218 0.83005v3.3206c0 0.45844-0.37703 0.83005-0.84218 0.83005h-4.248c-0.46514 0-0.84218-0.3716-0.84218-0.83005z",
  fill: "#fff",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m25.496 18.622v3.6742",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m18.681 22.67v-2.2025h14.83v2.3127",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
})), React.createElement("path", {
  d: "m22.534 23.387c0-0.4476 0.3955-0.8105 0.88331-0.8105h4.1957c0.48781 0 0.88331 0.3629 0.88331 0.8105v3.242c0 0.4476-0.3955 0.8105-0.88331 0.8105h-4.1957c-0.48781 0-0.88331-0.3629-0.88331-0.8105z",
  fill: "#fff",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m30.52 23.319c0-0.45514 0.39844-0.82415 0.88987-0.82415h4.2269c0.49143 0 0.88987 0.36902 0.88987 0.82415v3.2966c0 0.45514-0.39844 0.82415-0.88987 0.82415h-4.2269c-0.49143 0-0.88987-0.36902-0.88987-0.82415z",
  fill: "#fff",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(.61296 0 0 .61038 -1.0274 -2.8124)",
  strokeMiterlimit: 8
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m13.609 30.139c0.17217-0.12976 0.41691-0.09525 0.54667 0.07692l1.4226 1.8878c0.12972 0.17217 0.09532 0.41695-0.07685 0.54671l-1.2469 0.93957c-0.17217 0.12976-0.41691 0.09525-0.54667-0.07692l-1.4226-1.8878c-0.12976-0.17217-0.09536-0.41695 0.07681-0.54671z",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 1.6349
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m10.515 28.283 5.87 7.7312-5.3373 4.0523-5.87-7.7312z",
  fill: "#adb9ca",
  fillRule: "evenodd",
  strokeWidth: 1.6349
}), React.createElement("g", {
  className: "icon-primary",
  transform: "matrix(.35944 0 0 .35944 4.5252 16.225)",
  fill: "#ecaec6",
  fillRule: "evenodd",
  strokeWidth: 4.5484
}, React.createElement("path", {
  d: "m65.5 11.5c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10z"
}), React.createElement("path", {
  d: "m62.891 18.683c1.2159-0.0624 2.464 0.11251 3.6802 0.55476l0.10457 0.03801c1.2161 0.44229 2.285 1.11 3.1768 1.9391l0.14526 0.1997 1.6022 0.3526c1.1743 0.50863 2.1545 1.4654 2.6623 2.7494l5.9704 15.096 10.201-5.577c2.1238-1.1611 4.7868-0.38065 5.9479 1.7431l4.8e-5 -4.6e-5c1.1611 2.1238 0.38076 4.7867-1.743 5.9479-4.9999 2.7336-9.9999 5.4673-15 8.2009l-0.03848 0.01195-0.52538 0.34106c-2.5681 1.0157-5.4733-0.24282-6.4888-2.8109l-3.2249-8.1543-4.9543 13.623 12.036 10.887 0.78923 1.0684 0.57635 0.55622c0.38758 0.56396 0.65818 1.1947 0.80333 1.8531l0.02055 0.82737 0.73373 0.94741 8.4449 22.264c0.9997 2.6358-0.32649 5.5829-2.9623 6.5827-2.6357 0.99972-5.5829-0.32652-6.5826-2.9623-2.8149-7.4214-5.6299-14.843-8.4448-22.264l-0.06229-0.37815-11.499-7.3459-6.3581 15.768-0.7305 1.1089-0.32361 0.7331-0.45666 0.43508-1.0614 1.3388c-0.50378 0.43086-1.1006 0.77007-1.7723 0.98322l-22.697 7.2025c-2.687 0.85257-5.5563-0.6344-6.4089-3.3212-0.85272-2.6868 0.63426-5.5563 3.3212-6.4089l20.059-6.3655 4.5237-20.57-0.73047-1.7833c-0.43848-1.751-0.37674-3.6474 0.28672-5.4717l6.2768-17.26-8.3342 1.8193-0.51499 0.0081-10.685 10.412c-1.7336 1.6893-4.5084 1.6533-6.1976-0.08022l-2e-6 1.41e-4c-1.6893-1.7336-1.6533-4.5083 0.08022-6.1976l12.136-11.826 1.2306-1.2878c0.53042-0.37486 1.1433-0.65178 1.8178-0.79898l18.001-3.9297 0.51429-0.27062c0.84833-0.30123 1.742-0.48152 2.654-0.52848z"
})), React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.35944 0 0 .35944 -29.862 13.228)",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 4.5484
}, React.createElement("path", {
  d: "m112.34 41.884 16.331 21.509-14.849 11.274-16.331-21.509z"
}), React.createElement("path", {
  d: "m161.17 19.837c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10z"
}), React.createElement("path", {
  d: "m158.56 27.02c1.2159-0.0624 2.464 0.11251 3.6802 0.55476l0.10457 0.03801c1.2161 0.44229 2.285 1.11 3.1768 1.9391l0.14526 0.1997 1.6022 0.3526c1.1743 0.50863 2.1545 1.4654 2.6623 2.7494l5.9704 15.096 10.201-5.577c2.1238-1.1611 4.7868-0.38065 5.9479 1.7431l5e-5 -4.6e-5c1.1611 2.1238 0.38077 4.7867-1.743 5.9479-4.9999 2.7336-9.9999 5.4673-15 8.2009l-0.0385 0.01195-0.52539 0.34106c-2.5681 1.0157-5.4733-0.24282-6.4888-2.8109l-3.2249-8.1543-4.9543 13.623 12.036 10.887 0.78923 1.0684 0.57635 0.55622c0.38759 0.56396 0.65819 1.1947 0.80333 1.8531l0.0206 0.82737 0.73373 0.94741 8.4449 22.264c0.9997 2.6358-0.32649 5.5829-2.9623 6.5827-2.6357 0.99972-5.5829-0.32652-6.5826-2.9623-2.8149-7.4214-5.6299-14.843-8.4448-22.264l-0.0623-0.37815-11.499-7.3459-6.358 15.768-0.7305 1.1089-0.32362 0.7331-0.45666 0.43508-1.0614 1.3388c-0.50377 0.43086-1.1006 0.77007-1.7723 0.98322l-22.697 7.2025c-2.687 0.85258-5.5563-0.63439-6.4089-3.3212-0.85272-2.6868 0.63426-5.5563 3.3212-6.4089l20.059-6.3655 4.5237-20.57-0.73047-1.7833c-0.43848-1.751-0.37674-3.6474 0.28672-5.4717l6.2768-17.26-8.3342 1.8193-0.51499 0.0081-10.685 10.412c-1.7336 1.6893-4.5084 1.6533-6.1976-0.08022v1.41e-4c-1.6893-1.7336-1.6534-4.5083 0.0802-6.1976l12.136-11.826 1.2306-1.2878c0.53042-0.37486 1.1433-0.65178 1.8178-0.79898l18.001-3.9297 0.51429-0.27062c0.84832-0.30123 1.742-0.48152 2.654-0.52848z"
})));

var SvgMenuSummaryIcon = function SvgMenuSummaryIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuSummaryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-summary-icon.e744ca33.svg";
export { ForwardRef as ReactComponent };